// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AffiliateClickController from "./affiliate_click_controller"
application.register("affiliate-click", AffiliateClickController)

import AnalysisPollingController from "./analysis_polling_controller"
application.register("analysis-polling", AnalysisPollingController)

import AnalyticsEventController from "./analytics_event_controller"
application.register("analytics-event", AnalyticsEventController)

import AppPromoController from "./app_promo_controller"
application.register("app-promo", AppPromoController)

import AppUpdatePromptController from "./app_update_prompt_controller"
application.register("app-update-prompt", AppUpdatePromptController)

import ArchetypeRevealController from "./archetype_reveal_controller"
application.register("archetype-reveal", ArchetypeRevealController)

import ArticleTocController from "./article_toc_controller"
application.register("article-toc", ArticleTocController)

import AvatarUploadController from "./avatar_upload_controller"
application.register("avatar-upload", AvatarUploadController)

import AvoidedIngredientsController from "./avoided_ingredients_controller"
application.register("avoided-ingredients", AvoidedIngredientsController)

import BackToTopController from "./back_to_top_controller"
application.register("back-to-top", BackToTopController)

import BookmarkIconController from "./bookmark_icon_controller"
application.register("bookmark-icon", BookmarkIconController)

import BottomDrawerController from "./bottom_drawer_controller"
application.register("bottom-drawer", BottomDrawerController)

import BrandDuplicateController from "./brand_duplicate_controller"
application.register("brand-duplicate", BrandDuplicateController)

import BrandFilterController from "./brand_filter_controller"
application.register("brand-filter", BrandFilterController)

import BrandSelectController from "./brand_select_controller"
application.register("brand-select", BrandSelectController)

import Bridge__AppSearchController from "./bridge/app_search_controller"
application.register("bridge--app-search", Bridge__AppSearchController)

import Bridge__ButtonController from "./bridge/button_controller"
application.register("bridge--button", Bridge__ButtonController)

import Bridge__DoubleActionController from "./bridge/double_action_controller"
application.register("bridge--double-action", Bridge__DoubleActionController)

import Bridge__DoubleButtonController from "./bridge/double_button_controller"
application.register("bridge--double-button", Bridge__DoubleButtonController)

import Bridge__MenuController from "./bridge/menu_controller"
application.register("bridge--menu", Bridge__MenuController)

import Bridge__NavigationGuardController from "./bridge/navigation_guard_controller"
application.register("bridge--navigation-guard", Bridge__NavigationGuardController)

import Bridge__NotificationController from "./bridge/notification_controller"
application.register("bridge--notification", Bridge__NotificationController)

import Bridge__ProductPreviewController from "./bridge/product_preview_controller"
application.register("bridge--product-preview", Bridge__ProductPreviewController)

import Bridge__ProductScannerController from "./bridge/product_scanner_controller"
application.register("bridge--product-scanner", Bridge__ProductScannerController)

import Bridge__ProfileController from "./bridge/profile_controller"
application.register("bridge--profile", Bridge__ProfileController)

import Bridge__ScanButtonController from "./bridge/scan_button_controller"
application.register("bridge--scan-button", Bridge__ScanButtonController)

import Bridge__ShareButtonController from "./bridge/share_button_controller"
application.register("bridge--share-button", Bridge__ShareButtonController)

import Bridge__SingleActionController from "./bridge/single_action_controller"
application.register("bridge--single-action", Bridge__SingleActionController)

import BrushStrokeController from "./brush_stroke_controller"
application.register("brush-stroke", BrushStrokeController)

import CarouselCounterController from "./carousel_counter_controller"
application.register("carousel-counter", CarouselCounterController)

import CelebrationController from "./celebration_controller"
application.register("celebration", CelebrationController)

import CharacterCountController from "./character_count_controller"
application.register("character-count", CharacterCountController)

import CommentReplyController from "./comment_reply_controller"
application.register("comment-reply", CommentReplyController)

import ComparisonHighlightController from "./comparison_highlight_controller"
application.register("comparison-highlight", ComparisonHighlightController)

import ComparisonProductsController from "./comparison_products_controller"
application.register("comparison-products", ComparisonProductsController)

import CountryCarouselController from "./country_carousel_controller"
application.register("country-carousel", CountryCarouselController)

import DatePresetController from "./date_preset_controller"
application.register("date-preset", DatePresetController)

import DeleteProductController from "./delete_product_controller"
application.register("delete-product", DeleteProductController)

import DirectUploadStateController from "./direct_upload_state_controller"
application.register("direct-upload-state", DirectUploadStateController)

import DupeSearchController from "./dupe_search_controller"
application.register("dupe-search", DupeSearchController)

import EmailAddressConfirmationController from "./email_address_confirmation_controller"
application.register("email-address-confirmation", EmailAddressConfirmationController)

import ExpandingCircleController from "./expanding_circle_controller"
application.register("expanding-circle", ExpandingCircleController)

import ExpirationCalculatorController from "./expiration_calculator_controller"
application.register("expiration-calculator", ExpirationCalculatorController)

import ExpirationFormatController from "./expiration_format_controller"
application.register("expiration-format", ExpirationFormatController)

import FeatureUpdateController from "./feature_update_controller"
application.register("feature-update", FeatureUpdateController)

import FeatureUpdateDrawerController from "./feature_update_drawer_controller"
application.register("feature-update-drawer", FeatureUpdateDrawerController)

import FeedImpressionsController from "./feed_impressions_controller"
application.register("feed-impressions", FeedImpressionsController)

import FeedRefreshPromptController from "./feed_refresh_prompt_controller"
application.register("feed-refresh-prompt", FeedRefreshPromptController)

import FeedbackResolveController from "./feedback_resolve_controller"
application.register("feedback-resolve", FeedbackResolveController)

import FileInputStylingController from "./file_input_styling_controller"
application.register("file-input-styling", FileInputStylingController)

import FirstPlanController from "./first_plan_controller"
application.register("first-plan", FirstPlanController)

import FirstPlanRevealController from "./first_plan_reveal_controller"
application.register("first-plan-reveal", FirstPlanRevealController)

import FirstPlanTriggerController from "./first_plan_trigger_controller"
application.register("first-plan-trigger", FirstPlanTriggerController)

import FormDraftController from "./form_draft_controller"
application.register("form-draft", FormDraftController)

import FormStateController from "./form_state_controller"
application.register("form-state", FormStateController)

import FrameHistoryController from "./frame_history_controller"
application.register("frame-history", FrameHistoryController)

import GoalTimelineChartController from "./goal_timeline_chart_controller"
application.register("goal-timeline-chart", GoalTimelineChartController)

import GoogleSignInController from "./google_sign_in_controller"
application.register("google-sign-in", GoogleSignInController)

import HoldToCommitController from "./hold_to_commit_controller"
application.register("hold-to-commit", HoldToCommitController)

import HorizontalScrollController from "./horizontal_scroll_controller"
application.register("horizontal-scroll", HorizontalScrollController)

import ImageAnalysisController from "./image_analysis_controller"
application.register("image-analysis", ImageAnalysisController)

import ImageDropZoneController from "./image_drop_zone_controller"
application.register("image-drop-zone", ImageDropZoneController)

import ImageGalleryController from "./image_gallery_controller"
application.register("image-gallery", ImageGalleryController)

import InfluencerChartController from "./influencer_chart_controller"
application.register("influencer-chart", InfluencerChartController)

import InfluencerSearchController from "./influencer_search_controller"
application.register("influencer-search", InfluencerSearchController)

import IngredientDatabaseSearchController from "./ingredient_database_search_controller"
application.register("ingredient-database-search", IngredientDatabaseSearchController)

import IngredientListController from "./ingredient_list_controller"
application.register("ingredient-list", IngredientListController)

import IngredientListCopyController from "./ingredient_list_copy_controller"
application.register("ingredient-list-copy", IngredientListCopyController)

import IngredientMatchController from "./ingredient_match_controller"
application.register("ingredient-match", IngredientMatchController)

import LikeButtonController from "./like_button_controller"
application.register("like-button", LikeButtonController)

import LinkShareController from "./link_share_controller"
application.register("link-share", LinkShareController)

import ListFilterController from "./list_filter_controller"
application.register("list-filter", ListFilterController)

import LoadingButtonController from "./loading_button_controller"
application.register("loading-button", LoadingButtonController)

import MatchScoreBadgesController from "./match_score_badges_controller"
application.register("match-score-badges", MatchScoreBadgesController)

import MediavineIdentityController from "./mediavine_identity_controller"
application.register("mediavine-identity", MediavineIdentityController)

import MobileProductSearchController from "./mobile_product_search_controller"
application.register("mobile-product-search", MobileProductSearchController)

import ModalPresentationController from "./modal_presentation_controller"
application.register("modal-presentation", ModalPresentationController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import NotificationCountController from "./notification_count_controller"
application.register("notification-count", NotificationCountController)

import OnboardingController from "./onboarding_controller"
application.register("onboarding", OnboardingController)

import OnboardingProductSelectionController from "./onboarding_product_selection_controller"
application.register("onboarding-product-selection", OnboardingProductSelectionController)

import PaoSelectController from "./pao_select_controller"
application.register("pao-select", PaoSelectController)

import PhotoManagementController from "./photo_management_controller"
application.register("photo-management", PhotoManagementController)

import PreferencePickerController from "./preference_picker_controller"
application.register("preference-picker", PreferencePickerController)

import PremiumCheckoutController from "./premium_checkout_controller"
application.register("premium-checkout", PremiumCheckoutController)

import PremiumPaywallDrawerController from "./premium_paywall_drawer_controller"
application.register("premium-paywall-drawer", PremiumPaywallDrawerController)

import PreserveScrollController from "./preserve_scroll_controller"
application.register("preserve-scroll", PreserveScrollController)

import PriceRangeController from "./price_range_controller"
application.register("price-range", PriceRangeController)

import ProductDuplicateController from "./product_duplicate_controller"
application.register("product-duplicate", ProductDuplicateController)

import ProductFiltersController from "./product_filters_controller"
application.register("product-filters", ProductFiltersController)

import ProductResultsStateController from "./product_results_state_controller"
application.register("product-results-state", ProductResultsStateController)

import ProductSelectController from "./product_select_controller"
application.register("product-select", ProductSelectController)

import ProductsIndexRestoreController from "./products_index_restore_controller"
application.register("products-index-restore", ProductsIndexRestoreController)

import ProfileGenerationController from "./profile_generation_controller"
application.register("profile-generation", ProfileGenerationController)

import ProfileSetupController from "./profile_setup_controller"
application.register("profile-setup", ProfileSetupController)

import ReviewsFiltersController from "./reviews_filters_controller"
application.register("reviews-filters", ReviewsFiltersController)

import RoutineAddProductsController from "./routine_add_products_controller"
application.register("routine-add-products", RoutineAddProductsController)

import RoutineDayStripController from "./routine_day_strip_controller"
application.register("routine-day-strip", RoutineDayStripController)

import RoutineGuidanceController from "./routine_guidance_controller"
application.register("routine-guidance", RoutineGuidanceController)

import RoutineInsightsController from "./routine_insights_controller"
application.register("routine-insights", RoutineInsightsController)

import RoutineLogCustomProductSearchController from "./routine_log_custom_product_search_controller"
application.register("routine-log-custom-product-search", RoutineLogCustomProductSearchController)

import RoutineLogProductsController from "./routine_log_products_controller"
application.register("routine-log-products", RoutineLogProductsController)

import RoutineLogViewModeController from "./routine_log_view_mode_controller"
application.register("routine-log-view-mode", RoutineLogViewModeController)

import RoutineProjectionController from "./routine_projection_controller"
application.register("routine-projection", RoutineProjectionController)

import RoutineSectionSwitchController from "./routine_section_switch_controller"
application.register("routine-section-switch", RoutineSectionSwitchController)

import RoutineSortController from "./routine_sort_controller"
application.register("routine-sort", RoutineSortController)

import ScreeningReceiptController from "./screening_receipt_controller"
application.register("screening-receipt", ScreeningReceiptController)

import ScrollObserverController from "./scroll_observer_controller"
application.register("scroll-observer", ScrollObserverController)

import ScrollResetController from "./scroll_reset_controller"
application.register("scroll-reset", ScrollResetController)

import SearchBarController from "./search_bar_controller"
application.register("search-bar", SearchBarController)

import SearchConversionController from "./search_conversion_controller"
application.register("search-conversion", SearchConversionController)

import SearchHighlightController from "./search_highlight_controller"
application.register("search-highlight", SearchHighlightController)

import SectionTocController from "./section_toc_controller"
application.register("section-toc", SectionTocController)

import ShelfAddProductsController from "./shelf_add_products_controller"
application.register("shelf-add-products", ShelfAddProductsController)

import ShelfSearchController from "./shelf_search_controller"
application.register("shelf-search", ShelfSearchController)

import ShelfSelectionController from "./shelf_selection_controller"
application.register("shelf-selection", ShelfSelectionController)

import ShelfSortController from "./shelf_sort_controller"
application.register("shelf-sort", ShelfSortController)

import SkinRatingChartController from "./skin_rating_chart_controller"
application.register("skin-rating-chart", SkinRatingChartController)

import SkinTypeResultController from "./skin_type_result_controller"
application.register("skin-type-result", SkinTypeResultController)

import SmartSearchController from "./smart_search_controller"
application.register("smart-search", SmartSearchController)

import StagedRevealController from "./staged_reveal_controller"
application.register("staged-reveal", StagedRevealController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import StateChipsController from "./state_chips_controller"
application.register("state-chips", StateChipsController)

import StickyAppCtaController from "./sticky_app_cta_controller"
application.register("sticky-app-cta", StickyAppCtaController)

import StickyNavbarController from "./sticky_navbar_controller"
application.register("sticky-navbar", StickyNavbarController)

import StickyStuckController from "./sticky_stuck_controller"
application.register("sticky-stuck", StickyStuckController)

import SubmissionBatchSelectionController from "./submission_batch_selection_controller"
application.register("submission-batch-selection", SubmissionBatchSelectionController)

import SubmissionDuplicateCheckController from "./submission_duplicate_check_controller"
application.register("submission-duplicate-check", SubmissionDuplicateCheckController)

import SubmissionEvidenceController from "./submission_evidence_controller"
application.register("submission-evidence", SubmissionEvidenceController)

import SubmissionWorkspaceController from "./submission_workspace_controller"
application.register("submission-workspace", SubmissionWorkspaceController)

import SubscriptionCompletionController from "./subscription_completion_controller"
application.register("subscription-completion", SubscriptionCompletionController)

import TextFadeInController from "./text_fade_in_controller"
application.register("text-fade-in", TextFadeInController)

import TimeAgoController from "./time_ago_controller"
application.register("time-ago", TimeAgoController)

import TodayHeroController from "./today_hero_controller"
application.register("today-hero", TodayHeroController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import UnsavedChangesController from "./unsaved_changes_controller"
application.register("unsaved-changes", UnsavedChangesController)

import UrlUpdaterController from "./url_updater_controller"
application.register("url-updater", UrlUpdaterController)

import UserMentionController from "./user_mention_controller"
application.register("user-mention", UserMentionController)

import WebAnalyticsController from "./web_analytics_controller"
application.register("web-analytics", WebAnalyticsController)

import YearInReviewController from "./year_in_review_controller"
application.register("year-in-review", YearInReviewController)
